/**
 * @generated SignedSource<<350914ac854b64b6bbf111348aa33846>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type initCheckedCanSurveyQuery$variables = {
  refundHistoryId: string;
};
export type initCheckedCanSurveyQuery$data = {
  readonly getSurveyStatus: {
    readonly errors: {
      readonly code: ErrorType;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly result: boolean;
    readonly surveyStatus: {
      readonly surveyAnswerId: string | null | undefined;
    } | null | undefined;
  };
};
export type initCheckedCanSurveyQuery = {
  response: initCheckedCanSurveyQuery$data;
  variables: initCheckedCanSurveyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyStatusOutput",
    "kind": "LinkedField",
    "name": "getSurveyStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyStatus",
        "kind": "LinkedField",
        "name": "surveyStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyAnswerId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "initCheckedCanSurveyQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "initCheckedCanSurveyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "927b4abcd254f6963c14f289a4b3c92f",
    "id": null,
    "metadata": {},
    "name": "initCheckedCanSurveyQuery",
    "operationKind": "query",
    "text": "query initCheckedCanSurveyQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyStatus(refundHistoryId: $refundHistoryId) {\n    result\n    errors {\n      code\n      message\n    }\n    surveyStatus {\n      surveyAnswerId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "82a406468fee15c06b5f2bffc15d87ef";

export default node;
